import React, { CSSProperties } from "react";
import { colors } from "../variable";

export interface RadioCheckProps {
  color?: colors["value"];
  className?: string;
  name?: string;
  style?: CSSProperties;
  id?: number;
  value?: any;
  checked?: true | false;
  onChange?: () => void;
}

const RazorRadioCheck: React.FC<RadioCheckProps> = ({
  color,
  className,
  name,
  style,
  id,
  value,
  checked,
  onChange,
}) => {
  return (
    <div className={`radio-box-wrap ${className}`}>
      <input
        type="radio"
        id={`input-radio-${id}`}
        className="input-radio input-radio"
        style={style}
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
      />
      <label
        className={`label-radio label-radio__${color}`}
        htmlFor={`input-radio-${id}`}
      >
        <span className="check"></span>
      </label>
    </div>
  );
};

export default RazorRadioCheck;
